import './scss/p2p.scss'
import { p2p } from './p2p/p2p'

document.addEventListener('DOMContentLoaded', () => {
  // don't run on EN backend pages (e.g. form builder)
  if (window === window.top) {
    p2p()
  }
})
